module.exports = __webpack_public_path__ + "static/img/lc3_10.daa4cba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloudFilm/lc3_10.png
// module id = PaCy
// module chunks = 0